module.exports = __webpack_public_path__ + "static/media/contact.f60a390e.svg";